'kiwi public';

// Helper to generate Vues computed methods for simple channel modes.
// Eg. +i, +n, etc
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
function generateComputedMode(mode) {
  return {
    get: function get() {
      return this.modeVal(mode);
    },
    set: function set(newVal) {
      return this.setMode((newVal ? '+' : '-') + mode);
    }
  };
}

// Helper to generate Vues computed methods for channel modes with a parameter
// Eg. "+k key"
function generateComputedModeWithParam(mode) {
  return {
    get: function get() {
      var val = this.modeVal(mode);
      return val === false ? '' : val;
    },
    set: function set(newVal) {
      if (newVal) {
        this.setMode('+' + mode, newVal);
      } else {
        this.setMode('-' + mode, this.modeVal(mode));
      }
    }
  };
}
export default {
  props: ['buffer'],
  data: function data() {
    return {
      showPrevTopics: false
    };
  },
  computed: {
    modeM: generateComputedMode('m'),
    modeI: generateComputedMode('i'),
    modeS: generateComputedMode('s'),
    modeT: generateComputedMode('t'),
    modeN: generateComputedMode('n'),
    modeK: generateComputedModeWithParam('k'),
    topic: {
      get: function get() {
        return this.buffer.topic;
      },
      set: function set(newVal) {
        var newTopic = newVal.replace('\n', ' ');
        if (!_trimInstanceProperty(newTopic).call(newTopic)) {
          this.buffer.getNetwork().ircClient.raw("TOPIC ".concat(this.buffer.name, " :"));
        } else {
          this.buffer.getNetwork().ircClient.setTopic(this.buffer.name, newTopic);
        }
      }
    },
    prevTopics: function prevTopics() {
      var _context, _context2;
      return _filterInstanceProperty(_context = _sliceInstanceProperty(_context2 = this.buffer.topics).call(_context2, 1)).call(_context, function (topic) {
        return _trimInstanceProperty(topic).call(topic);
      });
    },
    areWeAnOp: function areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    }
  },
  methods: {
    setMode: function setMode(mode, param) {
      this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, mode, param);
    },
    modeVal: function modeVal(mode) {
      var val = false;
      if (typeof this.buffer.modes[mode] === 'undefined') {
        // Specifically undefined = mode not set
        val = false;
      } else if (!this.buffer.modes[mode]) {
        // Falsy value = mode set without value
        val = true;
      } else {
        // Anything else = mode set with a value
        val = this.buffer.modes[mode];
      }
      return val;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelInfo"]
window._kiwi_exports.components.ChannelInfo = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
